/* global axios */
import ApiClient from './ApiClient';

class TalkviaCalendarIntegrationAPI extends ApiClient {
  constructor() {
    super('talkvia_calendar_integration', { accountScoped: true });
  }

  delete() {
    return axios.delete(this.url);
  }

  update(data) {
    return axios.patch(this.url, { talkvia_calendar_integration: data });
  }

  updateAvailability(availability) {
    return axios.patch(`${this.url}/availability`, { availability });
  }

  generateAuthorization(data = {}) {
    return axios.post(`${this.url}/authorization`, data);
  }
}

export default new TalkviaCalendarIntegrationAPI();
